import { space, colors } from '@web-for-marketing/react-ui';

export const TableOfContentV2Styles = {
    containerToC: {
        padding: '1.6rem 2rem 0 1.6rem',
        marginBottom: '2.4rem',
        '& li::marker': {
            color: colors.text.secondary,
            fontSize: '1.4rem',
        },
        '& ul': {
            listStyle: 'none',
            padding: 0,
            marginLeft: '1.6rem',
        },
        '& li': {
            marginBottom: '1rem',
            position: 'relative',
        },
    },
    title: {
        marginBottom: '2.4rem',
    },
    listUl: {
        listStyleType: 'none',
        '& li': {
            marginBottom: '0.6rem',
        },
        '& ul': {
            marginTop: '0.6rem',
            paddingLeft: '1.6rem',
            '& li': {
                marginBottom: '0.6rem',
            },
        },
    },
    linkStyles: (isActive: boolean) =>
        ({
            padding: '0.4rem 0.8rem',
            textDecoration: 'none',
            paddingLeft: '0',
            display: 'block',
            position: 'relative',
            '&:hover': {
                color: colors.text.activePrimary,
            },
            '&:focus-visible': {
                color: colors.text.activePrimary,
                border: '1px solid',
                borderColor: colors.text.activePrimary,
                borderRadius: '0.4rem',
                outlineColor: colors.text.activePrimary,
            },
            '&:active': {
                outline: 'none',
            },
            '&::before': isActive
                ? {
                    content: '""',
                    position: 'absolute' as const,
                    left: '-1.6rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '2.5rem',
                    width: '3px',
                    backgroundColor: colors.border.activePrimary,
                    borderRadius: '0.4rem',
                }
                : undefined,
        }) as const,
    mobileContainer: {
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: colors.background.white,
        position: 'sticky',
        top: 0,
        zIndex: 2,
    },
    mobileTitleButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: colors.background.white,
        padding: `10px ${space.containerOuterPadding}`,
        border: 'none',
        borderTop: `1px solid ${colors.border.primary}`,
        borderBottom: `1px solid ${colors.border.primary}`,
        '&:focus-visible': {
            backgroundColor: colors.action.active,
            border: '1px solid',
            borderColor: colors.border.activePrimary,
            outlineColor: colors.text.activePrimary,
        },
    },
    rotate: {
        transform: 'rotate(180deg)',
    },
    listUlMobile: {
        width: '100%',
        padding: 0,
        margin: 0,
        listStyleType: 'none',
    },
    linkStylesMobile: {
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        padding: `10px ${space.containerOuterPadding}`,
        textDecoration: 'none',
        lineHeight: '2.2 !important',
        borderBottom: `1px solid ${colors.border.primary}`,
        transition: 'color 0.3s ease',
        '&:hover': {
            color: colors.text.activePrimary,
        },
        '&:focus-visible': {
            color: colors.text.activePrimary,
            outline: 'none',
        },
    },
    popover: {
        position: 'absolute',
        width: '100%',
        backgroundColor: colors.background.white,
        visibility: 'hidden',
        zIndex: 1001,
        transform: 'translateY(-2%) scale(0.95)',
        transition: 'transform ease 100ms',
    },
    showOpen: {
        opacity: 1,
        visibility: 'visible',
        height: 'auto',
        transform: 'none',
        transition: 'transform ease 300ms',
    },
    background: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 999,
        pointerEvents: 'auto',
    },
} as const;
